// บันทึกการเข้าดู/ส่งออกข้อมูลจากหน้าที่เข้าข่ายความลับ ไปยัง sensitive_access_log
// (ดู HRvec_api/sensitive_access_log.insert.php) — ทำงานเงียบเสมอ ห้ามรบกวน/บล็อกการใช้งานหน้าเดิม
// ไม่ว่ากรณีใด (แม้ request ล้มเหลวหรือ session หมดอายุ) — ไม่แสดง UI ใดๆ ให้ผู้ใช้เห็นว่ากำลังถูกบันทึก
export function logSensitiveAccess(httpClient, pageKey, action, context) {
  httpClient
    .post("sensitive_access_log.insert.php", {
      page_key: pageKey,
      action,
      context
    })
    .catch(() => {});
}
